import React from 'react';
import { Form } from 'antd';
import { FormItemProps } from 'antd/lib/form';

type FormItemProps2 = Omit<FormItemProps, 'children'>;
interface FormControlProps extends FormItemProps2 {
  name: string;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
}

export const FormControl: React.FC<FormControlProps> = ({ disabled, placeholder, children, ...props }) => {
  placeholder = placeholder || props.label;

  const child = React.Children.toArray(children)[0] as React.ReactElement;
  const newProps = { disabled, placeholder, ...child.props };
  const control = React.cloneElement(child, newProps);

  return (
    <Form.Item {...props}>
      {control}
    </Form.Item>
  );
};
